import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { getSrc } from "gatsby-plugin-image";
import SearchWidget from "../shared/SearchWidget";

export default function SectionOne({location}) {
  const data = useStaticQuery(graphql`
  query BannerQuery {
    allStrapiResortWebsites {
      edges {
        node {
          banner {
            url
          }
        }
      }
    }
  }
  `)
const {banner} = data.allStrapiResortWebsites.edges[0].node
return (
    <>
      <div className="relative overflow-y-hidden">
        <img
          alt="city skyline"
          src={banner.url}
          className="absolute h-full object-cover object-center w-full opacity-95"
        />
        <div className="absolute h-full w-full opacity-25 bg-gray-900 shadow-2xl" />
        <div className="mx-auto container lg:px-0s h-full relative">
          <div className="flex flex-col items-center sm:items-start justify-end lg:pb-28 pb-14 sm:pt-32 pt-16 sm:pl-16">
            <h1 className="text-6xl text-blue-50  pb-4 pl-2 sm:pl-0 font-extrabold">
              Find your next destination here!
            </h1>
            <h2 className="text-left text-2xl text-blue-50 sm:w-1/2 pl-2 sm:pl-0 font-bold">
            Search the fastest growing commercial real estate marketplace for free!
            </h2>
            <div className="sm:pb-48 sm:pt-12 pt-6">
              <div className="w-full flex-col flex items-center justify-center ">
                <SearchWidget location={location} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
